import { Component, OnInit, ChangeDetectorRef, ApplicationRef} from '@angular/core';
import { BaseService } from '../../../services/base.services';
import {NgbDate, NgbCalendar, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import pageSettings from '../../../config/page-settings';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { formatDate} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
declare var saveAs: any;
declare var moment: any;
declare var Highcharts: any;
declare var myExcelXML: any;
@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.html',
  styleUrls: ['dashboard.css']
})

export class DashboardPage implements OnInit{

  pageSettings = pageSettings;
  private data:Array<any> = [];
  isLinear = false;
  hoveredDate: NgbDate;
  fromDate: NgbDate;
  toDate: NgbDate;
  login = false; 
  response: any;
  dataSurvey:any;
  dataDashboard: any = false;
  country;
  public constructor(
    private baseService: BaseService,
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private cd : ChangeDetectorRef,
    private route: ActivatedRoute,
    private appRef: ApplicationRef
    ) {
      this.pageSettings.pageEmpty = true;
      this.fromDate = calendar.getPrev(calendar.getToday(), 'd', 5);
      this.toDate = calendar.getNext(calendar.getToday(), 'd', 0);
  }

  public ngOnInit():void {
    this.getHistory();
    this.getDashboard();

  }

  async getDashboard(){
    try{
      //var response:any = await this.baseService.getDashboard().toPromise();
      var response = [];
      this.dataDashboard = response;
    }catch(error){
      console.log(error);
    }
  }

  
  async getHistory(){
    try{
//      this.response = await this.baseService.getListSurvay(this.formatedDate(this.fromDate), this.formatedDate(this.toDate)).toPromise();
      this.response = [];
      if(this.response.length > 0){
        this.response.forEach(element => {
          element.respuestas = JSON.parse(element.respuestas);
          element.hora = moment(element.fecha, "YYYY-MM-DD HH:mm:ss").format("hh:mm");
          element.dia = moment(element.fecha, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");   
          element.html = this.getContain(element.respuestas);
          var _tieneSintomas =  false;
          if(element.respuestas.sintomas){
            element.respuestas.sintomas.forEach(x =>{
              if(x.id == 8  && x.checked == false){
                _tieneSintomas = true;
              }
            })
          }
          if(_tieneSintomas || element.respuestas.tuvoContacto == "Sí" || element.respuestas.estuvoExtrajero == "Sí" || element.respuestas.estaResfriado == "Sí"){
            element.tieneSintomas = true;
          }else{
            element.tieneSintomas = false;
          }           

        });
      }
      this.dataSurvey = this.response;
      this.chart();
      this.chart2();
    }catch(error){
      console.log(error);
    }
  }

  onDateSelection(date: NgbDate) {
    //console.log(date);
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
      this.getHistory();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  formatedDate(date: any) {
    //console.log(date);
    return moment(`${date.year}-${date.month}-${date.day}`).format("YYYY-MM-DD");
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
  }

  ConvertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      var str = '';
    var row = "";

    for (var index in objArray[0]) {
        //Now convert each value to string and comma-separated
        row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ','

            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  download(){    
    var _fIni = moment(this.formatedDate(this.fromDate), "YYYY-MM-DD").format("YYYY-MM-DD");
    var _fFin = moment(this.formatedDate(this.toDate), "YYYY-MM-DD").format("YYYY-MM-DD");
    var dataToCsv = [];
    if(this.dataSurvey){
      this.dataSurvey.forEach(x=>{
        x.hora = moment(x.fecha, "YYYY-MM-DD HH:mm:ss").format("hh:mm");
        x.dia = moment(x.fecha, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"); 
        var enfermedades = 'Ninguno';
        
        if(x.respuestas.enfermedades){
          enfermedades = this.cleanJson(x.respuestas.enfermedades.filter(x=> x.checked !== false && x.id !== 6 && x.id !== 5).map(y=>{return y.nombre;}));
        }

        var sintomas = 'Ninguno';
        if(x.respuestas.sintomas){
          sintomas = this.cleanJson(x.respuestas.sintomas.filter(x=> x.checked !== false && x.id !== 8).map(y=>{return y.nombre;}));
        }

        var data = {
          FechaDeRealizacion: x.dia,
          Hora: x.hora,
          Rut: x.rut,
          Nombre: x.nombre,
          Apellido: x.apellido,
          Email: x.email ? x.email: '',
          Empresa: x.respuestas.empresa,
          Sitio: x.respuestas.oficina,
          Telefono: x.Telefono ? x.Telefono : '',
          AntecendentesMedicos: enfermedades ? enfermedades : 'Ninguno',
          sintomas: sintomas ? sintomas : 'Ninguno',
          tuvoContacto: x.respuestas.tuvoContacto ? x.respuestas.tuvoContacto : 'No',
          estaResfriado: x.respuestas.estaResfriado ? x.respuestas.estaResfriado : 'No',
          estuvoExtrajero: x.respuestas.estuvoExtrajero ? x.respuestas.estuvoExtrajero : 'No',
        }

        dataToCsv.push(data);
      });
    }
    var universalBOM = "\uFEFF";

    var csvData = this.ConvertToCSV(dataToCsv);
                           var a = document.createElement("a");
                           a.setAttribute('style', 'display:none;');
                           document.body.appendChild(a);
                           var blob = new Blob([csvData], 
                           { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";' });
    /*                       var url= window.URL.createObjectURL(blob);
                           a.href = url;
                           a.download = 'encuestas-'+_fIni+'_'+_fFin+'.xls';
                           a.click();
      */
     //saveAs(blob, 'encuestas-'+_fIni+'_'+_fFin+'.xlsx');                     
     var myTestXML =  new myExcelXML(JSON.stringify(dataToCsv));
      myTestXML.downLoad();  
     return 'success';
   }

  cleanJson(data){
    var response = JSON.stringify(data).replace('[','').replace(']','').split('"').join('').split(',').join(';')
    return response;  
  }


   s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  getContain(data){
    var _sintomas = '';
    var _enfermedades = '';
    var _estuvoExtrajero = '';
    var _tuvoContacto = '';
    var _estaResfriado = '';
    if(data.sintomas){
      data.sintomas.forEach(x =>{
        if(x.id !== 8){
          var _checked = x.checked ? 'SI' : 'NO';
          if(x.checked){
            _sintomas = `${_sintomas} <p>¿Tienes ${x.nombre}? R= ${_checked}</p>`; 
          }

        }
      });
    }
    

    if(data.enfermedades){
      data.enfermedades.forEach(x =>{
        if(x.id !== 6 && x.id !== 5){
          _enfermedades = `${_enfermedades} <p>Padece de ${x.nombre}</p>`; 
        }
      });

    }

    if(data.estuvoExtrajero == 'Sí'){
      _estuvoExtrajero = `<p>¿Ha visitado el extrajero los últimos 14 días? R= ${data.estuvoExtrajero}</p>`
    }

    if(data.estaResfriado == 'Sí'){
      _estaResfriado = `<p>¿Se encuentra hoy Resfriado? R= ${data.estaResfriado}</p>`
    }

    if(data.tuvoContacto == 'Sí'){
      _tuvoContacto = `<p>¿Ha tenido contacto con algún caso confirmado o sospechoso (en espera de resultados) de COVID-19 en los ultimos 14 días? R= ${data.tuvoContacto}</p>`
    }

    return `
      <p>Pertenece a la empresa ${data.empresa}</p>
      <p>Se dirige a la oficina R= ${data.oficina}</p>
      ${_estuvoExtrajero}
      ${_estaResfriado}
      ${_tuvoContacto}
      ${_sintomas}
      ${_enfermedades}
    `; 
  };

  chart(){
/*
    var listSymptoms = [
      {id: 1, name: 'Fiebre >37,8°', y: this.dataSurvey.respuestas.sintomas.filter(x=> x.id== 1 && x.checked == true).length},
      {id: 2, name: 'Dolor de cabeza o gargata', y: this.dataSurvey.respuestas.sintomas.filter(x=> x.id== 2 && x.checked == true).length},
      {id: 3, name: 'Dolor muscular', y: this.dataSurvey.respuestas.sintomas.filter(x=> x.id== 3 && x.checked == true).length},
      {id: 4, name: 'Tos seca', y: this.dataSurvey.respuestas.sintomas.filter(x=> x.id== 4 && x.checked == true).length},
      {id: 5, name: 'Dificultad para respirar', y: this.dataSurvey.respuestas.sintomas.filter(x=> x.id==5  && x.checked == true).length},
      {id: 6, name: 'Pérdida de olfato o gusto.', y: this.dataSurvey.respuestas.sintomas.filter(x=> x.id== 6 && x.checked == true).length},
      {id: 7, name: 'Temblores y escalofríos.', y: this.dataSurvey.respuestas.sintomas.filter(x=> x.id== 7 && x.checked == true).length},
      {id: 8, name: 'Ningún Síntoma', y: this.dataSurvey.respuestas.sintomas.filter(x=> x.id== 8 && x.checked == true).length},
    ];
  */
  var dates = this.getDates();
  
  var listOffices = [
    {id: 1, nombre: 'Oficina CI12 (El Bosque Norte N° 500)', pais: 'chile'},
    {id: 2, nombre: 'Oficina CI08 (Monseñor Sotero Sanz N° 55)', pais: 'chile'},
    {id: 3, nombre: 'Oficina CI15 (Antofagasta)', pais: 'chile'},
    {id: 4, nombre: 'Codelco (Divisiones)', pais: 'chile'},
    {id: 5, nombre: 'ENEL', pais: 'chile'},
    {id: 6, nombre: 'Otra oficina', pais: 'chile'},
  ];


  var dataChart = [];
  
  listOffices.forEach(x=>{
    dataChart.push({name: x.nombre, data: this.getDataChart('oficina', x.id, dates)});
  })

  dataChart.push({name: 'Todos', data: this.getDataChartAll(dates)});

  Highcharts.chart('chart', {
      chart: {
          type: 'line',
          backgroundColor: 'rgba(0,0,0,0)',
      },
      title: {
          text: ''
      },
      subtitle: {
          text: ''
      },
      xAxis: {
          categories: dates
      },
      yAxis: {
          title: {
              text: 'Cantidad'
          }
      },
      credits: {
        enabled: false
      },
      tooltip: {
        shared: true,
        crosshairs: true
      },
      plotOptions: {
          line: {
              dataLabels: {
                  enabled: true
              },
              enableMouseTracking: true
          }
      },
      series: dataChart
   });
  }

  chart2(){
 
    var dates = this.getDates();
    
    var listCompany = [
      {id: 1, nombre: 'Honeywell', pais: 'chile', checked: true},
      {id: 2, nombre: 'Kairos Mining S.A.', pais: 'chile',  checked: false},
      {id: 3, nombre: 'Expro', pais: 'chile',  checked: false},
      {id: 4, nombre: 'Esim', pais: 'chile',  checked: false},
      {id: 5, nombre: 'Ambar', pais: 'chile',  checked: false},
      {id: 6, nombre: 'Otra', pais: 'chile',  checked: false}
    ];
  
    var dataChart = [];
    
    listCompany.forEach(x=>{
      dataChart.push({name: x.nombre, data: this.getDataChart('empresa', x.id, dates)});
    })
  
    dataChart.push({name: 'Todos', data: this.getDataChartAll(dates)});
  
    Highcharts.chart('chart2', {
        chart: {
            type: 'column',
            backgroundColor: 'rgba(0,0,0,0)',
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            categories: dates
        },
        yAxis: {
            title: {
                text: 'Cantidad'
            }
        },
        credits: {
          enabled: false
        },
        tooltip: {
          shared: true,
          crosshairs: true
        },
        plotOptions: {
            line: {
                dataLabels: {
                    enabled: true
                },
                enableMouseTracking: true
            }
        },
        series: dataChart
      });
  }
    
  
  getDataChart(type, idOficina, dates){
    var arrayData = [];
    var _data = [];
    if(type == 'empresa'){
      _data = this.dataSurvey.filter(x=> x.idEmpresa == idOficina);
    }
    if(type =='oficina'){
      _data = this.dataSurvey.filter(x=> x.respuestas.idOficina == idOficina);
    }

    dates.forEach(y=>{
      var data = 0
      _data.forEach((x, i)=> {
        
        var diaEncuesta = moment(x.dia, 'YYYY-MM-DD').format('YYYY-MM-DD');
        console.log(y+' = '+diaEncuesta); 
        if(y == diaEncuesta){
          data = data + 1;
        }
      });

      arrayData.push(data);
    });  
    return arrayData;
  }

  getDataChartAll(dates){
    var arrayData = [];
    var _data = this.dataSurvey;
    dates.forEach(y=>{
      var data = 0
      _data.forEach(x=> {
        
        var diaEncuesta =  moment(x.fecha).format('YYYY-MM-DD'); 
        if(y == diaEncuesta){

          data = data + 1;
        }
      });

      arrayData.push(data);
    });  
    return arrayData;
  }

  getDates() {
    var startDate = this.formatedDate(this.fromDate);
    var stopDate = this.formatedDate(this.toDate);
    var dateArray = [];
    var currentDate = moment(startDate);
    var stopDate = moment(stopDate);
    while (currentDate <= stopDate) {
        dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
  }
}
